import axios from "axios";

const Api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json"
  }
});

export default {
  health: (config = {}) => Api.get("/api/health", config),
  // Deprecated: prefer health() for frontend polling.
  status: () => Api.get("/api/cars/status"),
  request: body => Api.post("/api/cars/request", body),
  confirm: body => Api.post("/api/cars/confirm", body),
  validateSearch: body => Api.post("/api/cars/validate-search", body)
};
